// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Verification_confirm__0oEOf","confirm-tit":"Verification_confirm-tit__Xs7Or","confirmTit":"Verification_confirm-tit__Xs7Or"};